import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import './dx-styles.scss';
import LoadPanel from 'devextreme-react/load-panel';
import { NavigationProvider } from './contexts/navigation';
import { AuthProvider, useAuth } from './contexts/auth';
import { useScreenSizeClass } from './utils/media-query';
import Content from './Content';
import UnauthenticatedContent from './UnauthenticatedContent';
import { ResourceManager } from 'devexpress-dashboard';
import { locale } from "devextreme/localization";
import { useEffect } from 'react';

function App() {
  const { user, loading } = useAuth();
  var culture = "no";
  ResourceManager.setLocalizationMessages(require(`../json resources/dx-dashboard.${culture}.json`));
  ResourceManager.setLocalizationMessages(require(`../json resources/dx-analytics-core.${culture}.json`));
  locale(culture);

  useEffect(() => {
    if (window.location.hostname !=='localhost' && window.location.protocol === 'http:') {
      window.location.href =
        window.location.href.replace(
          'http:', 'https:');
    }
  }, []);

  if (loading) {
    return <LoadPanel visible={true} />;
  }

  if (user) {
    return <Content />;
  }

  return <UnauthenticatedContent />;
}

export default function Root() {
  const screenSizeClass = useScreenSizeClass();

  return (
    <Router>
      <AuthProvider>
        <NavigationProvider>
          <div className={`app ${screenSizeClass}`}>
            <App />
          </div>
        </NavigationProvider>
      </AuthProvider>
    </Router>
  );
}
